import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import View from "@modul-connect/shared/components/atoms/view";
import Page from "@modul-connect/shared/components/atoms/page";
import SideBar from "@modul-connect/shared/components/organisms/side-bar";
import SideBarLink from "@modul-connect/shared/components/organisms/side-bar-link";
import MainContainer from "@modul-connect/shared/components/organisms/main-container";
import { useParams, useNavigate } from "react-router-dom";
import ModalAjaxError from "@modul-connect/shared/components/organisms/modal-ajax-error";
import { dismissAjaxError } from "../../state/actions/app"
import FirmwareReport from "./firmwares/firmware_report"
import Users from "./users/users";
import Vehicles from "./vehicles/vehicles";
import Templates from "./templates/templates";
import ConnectionStatus from "./connectionStatus";
import DisturbancePage from "./disturbance/disturbancePage";

const Reports = ({ themes, saving, dismissAjaxError, role }) => {
  const navigate = useNavigate()
  const { option, id, subId, detail } = useParams()

  const [selected, setSelected] = useState(null);
  const menuState = selected !== null;

  useEffect(() => {
    if (option) {
      const [category, title] = option.replace('-', ' ').split('_')

      const catIndex = sidebarContent.findIndex(x => category.includes(x.categoryId.toLowerCase()))

      if (catIndex < 0) {
        navigate('/reports/general_vehicles')
        return
      }
      const titleIndex = sidebarContent[catIndex].titles.findIndex(x => title.includes(x.title.toLowerCase()))
      if (titleIndex < 0) {
        navigate('/reports/general_vehicles')
        return
      }

      setSelected([catIndex, titleIndex])
    }
  }, [option])

  const onSetSelected = array => {
    let url = '/reports'

    if (array !== null) {
      url = url + '/' + sidebarContent[array[0]].categoryId.toLowerCase() +
                  '_' + sidebarContent[array[0]].titles[array[1]].title.replace(' ', '-').toLowerCase()
      navigate(url)
    }
  }

  const filterCategories = (category) => {
    category.titles = category.titles.filter(title => {
      return !title.role || title.role == role
    })
    return category
  }

  return (
    <Page>
      <View extend={styles.settings}>

      <ModalAjaxError
        openModal={ saving && saving.ajaxError }
        onClose={ dismissAjaxError }
      />
        <MainContainer themes={themes} extend={[ styles.main ]} >
          {menuState && (
            <View>
              {selected[0] === 0 && selected[1] === 0 ? <Users id={id} subId={subId} detail={detail} /> 
                : selected[0] === 0 && selected[1] === 1 ? <Vehicles id={id} /> 
                : sidebarContent[selected[0]].titles[selected[1]].content}
            </View>
          )}
        </MainContainer>
        <SideBar themes={themes} extend={styles.sidebar}>
          {sidebarContent.filter(category => { return filterCategories(category)}).map((category, catIndex) =>
            <SideBarLink
              key={catIndex}
              category={category}
              catIndex={catIndex}
              selected={selected}
              history={navigate}
              sidebarContent={sidebarContent}
              onClick={ onSetSelected }
            />
          )}

        </SideBar>
      </View>
    </Page>
  );
};

const sidebarContent = [
  {
    category: 'General',
    categoryId: 'general',
    titles: [
        {title: 'Users', content: <Users />, icon: 'MdSupervisorAccount', role: 1 },
        {title: 'Vehicles', content: <Vehicles />, icon: 'MdDirectionsCar' }
      ]
  },
  {
    category: 'Connections',
    categoryId: 'connection',
    titles: [
      {title: 'Disconnected vehicles', content: <ConnectionStatus />, icon: 'MdDirectionsCar' }
    ]
  },
  {
    category: 'Others',
    categoryId: 'others',
    titles: [
        {title: 'Firmwares', content: <FirmwareReport />, icon: 'MdCloud' },
        {title: 'Templates', content: <Templates />, icon: 'MdTemplates' },
        {title: 'Disturbance', content: <DisturbancePage />, icon: 'Disturbance' },
      ]
  }
];

const styles = {
  settings: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  sidebar: ({ theme: { colors } }) => ({
    width: '200px',
    backgroundColor: colors.white,
    '> a': {
      paddingTop: '8px',
      transition: "color 200ms ease-in-out",
      '&:hover': {
        color: colors.primary
      },
      '&:active': {
        color: colors.white
      }
    }
  }),
  main: {
    padding: "0 16px",
    left: '200px',
    right: 0,
    bottom: 0
  },
};

const mapStateToProps = props => props;

const mapDispatchToProps = dispatch => ({
  dismissAjaxError: () => dispatch(dismissAjaxError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);